const auth = 'authentication'
const landing = 'landing'
const customer = 'customer'
const booking = 'booking'
const account = 'account'
const faqs = 'faqs'

export const ROUTE_CONFIGS = {

  // AUTH
  AUTH: `${auth}`,
  LOGIN: `login`,
  LOGIN_ROUTE: `/${auth}/login`,
  SIGNUP_ROUTE: `/signup`,
  ORGANIZATION_ROUTE: `/${auth}/login?organisation=true`,
  FORGOT_PASSWORD: `forgotPassword`,
  FORGOT_PASSWORD_ROUTE: `/${auth}/forgotPassword`,
  RESET_PASSWORD: `resetPassword`,
  RESET_PASSWORD_ROUTE: `/${auth}/resetPassword`,


  //LANDING
  LANDING: ``,
  BOOKING: `${booking}`,
  CUSTOMER: `${customer}`,
  CUSTOMER_BOOKING_ROUTE: `/${customer}/booking`,
  CUSTOMER_PROFILE_ROUTE: `/${customer}/account/profile`,

  //CUSTOMER
  PROFILE: `profile`,
  ACCOUNT: `${account}`,
  MANAGE_ACCOUNT: `manage-account`,
  MY_ORDERS: `my-orders`,
  NOTIFICATIONS: `notifications`,
  MANAGE_ACCOUNT_ROUTE: `/${customer}/account/manage-account`,
  MY_ORDERS_ROUTE: `/${customer}/account/my-orders`,
  MY_ORDERS_DETAILS: `my-order-details`,
  MY_ORDER_DETAILS_ROUTE: `/${customer}/account/my-order-details`,
  NOTIFICATIONS_ROUTE: `/${customer}/account/notifications`,

  ORGANIZATION_BOOKING: `organization-booking`,
  ORGANIZATION_BOOKING_ROUTE: `/${customer}/${booking}/organization-booking`,


  //FAQS
  FAQS: `${faqs}`,
  FAQS_ROUTE: `/${landing}/faqs`,
  //HELP
  HELP_ROUTE: `https://bringitnow.net/contact-us`,
  //TERMS & PRIVACY
  TERMS_CONDITION_ROUTE: `https://bringitnow.net/terms-and-conditions`,
  PRIVACY_POLICY_ROUTE: `https://bringitnow.net/privacy-policy`,
  //APP LINKS
  ANDROID_APP_ROUTE: `https://play.google.com/store/apps/details?id=com.bringitnow.customer&hl=en_IN`,
  IOS_APP_ROUTE: `https://apps.apple.com/us/app/bring-it-now-customer/id1536149155`,
  FAQS_ROUTES: `faqs`,
  //LANGUAGES
  LANGUAGES_ROUTE: `/${landing}/languages`,

}
